/*jshint esversion: 9 */
import {
  mapGetters,
  mapActions
 } from 'vuex';

import WaggonInfo from '@/components/ProjectTaktPlan/WaggonInfo.component.vue';
import WaggonInfoStatus from '@/components/ProjectTaktPlan/WaggonInfoStatus.component.vue';
import WaggonInfoHeader from '@/components/ProjectTaktPlan/WaggonInfoHeader.component.vue';
import WaggonInfoHeaderAdd from '@/components/ProjectTaktPlan/WaggonInfoHeaderAdd.component.vue';
import WaggonInfoBody from '@/components/ProjectTaktPlan/WaggonInfoBody.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
import StandardStep from '@/components/StandardComponents/StandardStep.component.vue';
import StandardStepAdd from '@/components/StandardComponents/StandardStepAdd.component.vue';
import WaggonInfoNavButton from '@/components/ProjectTaktPlan/WaggonInfoNavButton.component.vue';
import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue';
import StepCalculation from '@/components/StandardComponents/StandardStepCalculation.component.vue'
import { getFileTypeFromExtenion } from '@/helpers/util.js';

export const WaggonInfoMixin = {
  components: {
    WaggonInfo,
    WaggonInfoStatus,
    WaggonInfoHeader,
    WaggonInfoHeaderAdd,
    WaggonInfoBody,
    StandardDataField,
    StandardOverflowButton,
    StandardFlexBox,
    StandardDeleteButton,
    StandardStep,
    StandardStepAdd,
    WaggonInfoNavButton,
    StandardDialogFullScreen,
    StandardDropdown,
    StepCalculation
  },
  data: () => ({
    nav_direction: 'right',
    nav_direction_image: 'right',
    update_key_add_comment: 0,
    update_key_add_image: 0,
    update_key_add_work_step: 0,
    update_key_add_quality_step: 0,
    update_key_add_defect_step: 0,
    update_key_add_handover_step: 0,
    update_key_add_design_step: 0,
    update_key_add_logistic_step: 0,
    update_key_add_cost_step: 0,
    new_image: {
      file: false,
      local_url: false,
      name: false,
      comment: '',
      extension: '',
      type: 'other'
    },
    new_step_image: {
      file: false,
      local_url: false,
      name: false,
      comment: '',
      step_id: false,
      extension: '',
      type: 'other',
      step_type: 'other'
    },
    draggable_steps: false,
    add_step_type: '',
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject',
      ],
    ),
    ...mapGetters('TWaggon', [
      'getTWaggon',
      ],
    ),
    ...mapGetters('TWorkPackage', [
      'getTWorkPackage',
      'getTWPBudgetPrice',
      'getTWPTenderedPrice',
      'getTWPToBePaidPrice',
      'getCostStrategies'
      ],
    ),
    ...mapGetters('WorkPackageLogList', [
      'getWorkPackageLogList',
      'getLogListFilter',
    ]),
    ...mapGetters('Project', [
      'isEditMode',
      'getEditKey',
      'getStatusArray',
      'hasProjectPermission',
      'getOwnTWorkPackages',
    ]),
    ...mapGetters('View', [
      'getSnackBar',
    ]),
    ...mapGetters('TaktArea', [
      'getTaktarea'
    ]),
    ...mapGetters('Auth', [
      'isLoggedIn',
      'hasPermission',
      'isCloudPrint',
    ]),
    ...mapGetters('ProjectStructure', [
      'getElementsTotalValue'
    ]),
    getWaggonInfoNavigation: function() {
      switch (this.$route.matched[4].name) {
        case 'TaktPlanWorkPackageInfo':
          return {
            up: 'TaktPlanWorkPackageMaterialSteps',
            right: 'TaktPlanWorkPackageLogList',
            down: 'TaktPlanWorkPackageWorkSteps',
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageMaterialSteps':
          return {
            up: false,
            right: false,
            down: 'TaktPlanWorkPackageInfo',
            left: false,
          };
        case 'TaktPlanWorkPackageWorkSteps':
          return {
            up: 'TaktPlanWorkPackageInfo',
            right: 'TaktPlanWorkPackageImages',
            down: 'TaktPlanWorkPackageQualitySteps',
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageQualitySteps':
          return {
            up: 'TaktPlanWorkPackageWorkSteps',
            right: 'TaktPlanWorkPackageMessageBoard',
            down: 'TaktPlanWorkPackageDefectSteps',
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageDefectSteps':
          return {
            up: 'TaktPlanWorkPackageQualitySteps',
            right: 'TaktPlanWorkPackageMessageBoard',
            down: 'TaktPlanWorkPackageHandoverSteps',
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageHandoverSteps':
          return {
            up: 'TaktPlanWorkPackageDefectSteps',
            right: 'TaktPlanWorkPackageMessageBoard',
            down: 'TaktPlanWorkPackageDesignSteps',
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageDesignSteps':
          return {
            up: 'TaktPlanWorkPackageHandoverSteps',
            right: 'TaktPlanWorkPackageMessageBoard',
            down: 'TaktPlanWorkPackageLogisticSteps',
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageLogisticSteps':
          return {
            up: 'TaktPlanWorkPackageDesignSteps',
            right: 'TaktPlanWorkPackageMessageBoard',
            down: 'TaktPlanWorkPackageCostSteps',
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageCostSteps':
        return {
          up: 'TaktPlanWorkPackageLogisticSteps',
          right: 'TaktPlanWorkPackageMessageBoard',
          down: 'TaktPlanWorkPackageNoSteps',
          left: 'TaktPlanWorkPackageCosts',
        };
        case 'TaktPlanWorkPackageNoSteps':
          return {
            up: 'TaktPlanWorkPackageCostSteps',
            right: 'TaktPlanWorkPackageMessageBoard',
            down: false,
            left: 'TaktPlanWorkPackageCosts',
          };
        case 'TaktPlanWorkPackageNoMaterialSteps':
          return {
            up: false,
            right: false,
            down: 'TaktPlanWorkPackageInfo',
            left: false,
          };
        case 'TaktPlanWorkPackageLogList':
          return {
            up: false,
            right: false,
            down: 'TaktPlanWorkPackageImages',
            left: 'TaktPlanWorkPackageInfo',
          };
        case 'TaktPlanWorkPackageImages':
          return {
            up: 'TaktPlanWorkPackageLogList',
            right: false,
            down: 'TaktPlanWorkPackageMessageBoard',
            left: 'TaktPlanWorkPackageWorkSteps',
          };
        case 'TaktPlanWorkPackageMessageBoard':
        return {
          up: 'TaktPlanWorkPackageImages',
          right: false,
          down: false,
          left: 'TaktPlanWorkPackageQualitySteps',
        };
        case 'TaktPlanWorkPackageCosts':
          return {
            up: false,
            right: 'TaktPlanWorkPackageInfo',
            down: false,
            left: false,
          };
      }
    },
  },
  methods: {
    ...mapActions('Ultra', [
      'updateUObjectPosition',
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'requestUObject'
    ]),
    ...mapActions('UltraDev', [
      'updateUDObject',
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbar',
      'requestSnackbarCreate',
      'requestSnackbarUpdate',
      'requestSnackbarUpdatePosition',
      'requestSnackbarDelete',
      'updateSnackbar'
    ]),
    ...mapActions('ProjectWallet', [
      'updateStepCardStatus',
      'increaseUpdateKeyStepCard'
    ]),
    ...mapActions('WorkBenchLocal', [
      'updateWBLObject',
    ]),
    ...mapActions('WorkPackageLogList', [
      'setLogListFilter',
      'createLogListComment',
      'updateLoglistEntry',
      'requestWorkPackageLogList'
    ]),
    // ...mapActions('TWorkPackageImage', [
    //   'uploadImage',
    //   'uploadStepImage',
    //   'deleteTWorkPackageFile'
    // ]),
    ...mapActions('TWorkPackage', [
      'addStepImage'
    ]),
    ...mapActions('TWaggon', [
      // 'tWorkPackageDelete',
      'tWorkPackageChangePosition',
    ]),
    ...mapActions('ProjectMilestone', [
      'updateMilestoneStatus'
    ]),
    changeValue(target, value){
      this.requestSnackbarUpdate({
        url: [
          {projects: this.project_id},
          {trains: this.train_id},
          {taktareas: this.taktarea_id},
          {twaggons: this.twaggon_id},
          {tworkpackages: this.tworkpackage_id}
        ],
        update: {
          [target]: value
        },
      }).then((payload) => {
        this.updateUObject(payload);
      });
      // this.updateTWorkPackageBulk({
      //   project_id: parseInt(this.project_id),
      //   train_id: this.train_id,
      //   // taktarea_id: this.taktarea_id,
      //   // twaggon_id: this.twaggon_id,
      //   update: {
      //     [target]: value,
      //   },
      //   work_packages: [{
      //     id: this.tworkpackage_id
      //   }],
      //   snack_bar: {
      //     bulk: false,
      //     check_old_value: this.getSnackBar.check_old_value,
      //   },
      // });
    },
    getHeaderWidth(work_package_id) {
      if (this.$route.name === 'TaktPlanAddWorkPackage' ||
          this.$route.name === 'TaktPlanAddWorkPackageCustom'
        ) {
        return '25px';
      }
      else if (work_package_id === this.tworkpackage_id) {
        return '100%';
      } else {
        // return '20%';
        return '100%';
      }
    },
    getLogListIcon(entry) {
      switch(entry.action) {
        case 'created':
          return 'add';
        case 'added':
          return 'add';
        case 'removed':
          return 'remove';
        case 'deleted':
          return 'remove';
        case 'updated':
          return 'build';
        case 'created comment':
          return 'sms';
      }
    },
    selectWorkpackageImage(image) {
      let image_name = image.name;
      let arr = image_name.split(".");
      let ext = arr[arr.length-1];

      let type = getFileTypeFromExtenion(ext);

      this.new_image.extension = ext;
      this.new_image.file = image;
      this.new_image.local_url = URL.createObjectURL(image);
      this.new_image.name = image.name;
      this.new_image.type = type;
      this.update_key_add_image++;
    },
    uploadWorkpackageImage() {
      if (this.new_image.file) {
      let image = new FormData();
      image.append("image", this.new_image.file);
      this.createUObject({
        url: [
          {projects: this.project_id},
          {trains: this.train_id},
          {taktareas: this.taktarea_id},
          {twaggons: this.twaggon_id},
          {tworkpackages: this.tworkpackage_id},
          {tworkpackageimages: ''},
          {showWithEntitiesNormalized: ''},
        ],
        image: image
      }).then(id => {
        this.updateUObject({
          url: [
            {projects: this.project_id},
            {trains: this.train_id},
            {taktareas: this.taktarea_id},
            {twaggons: this.twaggon_id},
            {tworkpackages: this.tworkpackage_id},
            {tworkpackageimages: id}
          ],
          update: {
            comment: this.new_image.comment
          }
        }).then(() => {
          this.new_image = {
            file: false,
            local_url: false,
            name: false,
            comment: '',
            extension: '',
            type: 'other'
          };
          this.update_key_add_image++;
        });
      });
    }
  },
  selectStepImage(image, step_type, step_id){
    let arr = image.name.split(".");
    let ext = arr[arr.length-1];
    let file_type = getFileTypeFromExtenion(ext);

    this.new_step_image = {
      file: image,
      local_url: URL.createObjectURL(image),
      name: image.name,
      comment: '',
      step_id: step_id,
      type: file_type,
      extension: ext,
      step_type: step_type
    };
    this.update_key_add_image++;
  },
  uploadStepImage(step_id) {
    if (this.new_step_image.file) {
    let image = new FormData();
    image.append("image", this.new_step_image.file);

    this.createUObject({
      url: [
        {projects: this.project_id},
        {trains: this.train_id},
        {taktareas: this.taktarea_id},
        {twaggons: this.twaggon_id},
        {tworkpackages: this.tworkpackage_id},
        {[`t${this.step_type}steps`]: step_id},
        {tworkpackageimages: ''},
        {showWithEntitiesNormalized: ''},
      ],
      image: image
    }).then(id => {
      this.addStepImage({
        tworkpackage_id: this.tworkpackage_id,
        image_id: id
      });
      this.updateUObject({
        url: [
          {projects: this.project_id},
          {trains: this.train_id},
          {taktareas: this.taktarea_id},
          {twaggons: this.twaggon_id},
          {tworkpackages: this.tworkpackage_id},
          {tworkpackageimages: id}
        ],
        update: {
          comment: this.new_step_image.comment
        }
      }).then(() => {
        this.new_step_image = {
          file: false,
          local_url: false,
          name: false,
          comment: '',
          step_id: false,
          extension: '',
          type: 'other'
        };
        this.update_key_add_image++;
      });
    });
  }
},
downloadFile(url, name, extension){
  let filename = name + "." + extension;
  fetch(url).then(function(t) {
      return t.blob().then((b)=>{
        var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", filename);
          a.click();
      }
      );
  });
},
toggleCrossedOut(entry){
  this.updateLoglistEntry({
    project_id: this.project_id,
    train_id: this.train_id,
    taktarea_id: this.taktarea_id,
    twaggon_id: this.twaggon_id,
    twork_package_id: this.tworkpackage_id,
    wbgroup_id: this.$route.params.wbgroup_id,
    wbline_id: this.$route.params.wbline_id,
    wbworkpackage_id: this.$route.params.wbworkpackage_id,
    backlog: this.backlog,
    entry_id: entry.id,
    update: {
      crossed_out: !entry.crossed_out
    }
  });
  },
  getNestedWorkPackageCopy(work_package_id, add_steps, prefix) {

    return new Promise((resolve_complete) => {
      // call workpackage here because steps??
      let url;
      if (this.backlog) {
        url = [
          {projects: this.$route.params.project_id},
          {wbgroups: this.$route.params.wbgroup_id},
          {wblines: this.$route.params.wbline_id},
          {wbworkpackages: work_package_id},
          {showWithEntitiesNormalized: ''}
        ];
      } else {
        url = [
          {projects: this.project_id},
          {trains: this.train_id},
          {taktareas: this.taktarea_id},
          {twaggons: this.twaggon_id},
          {tworkpackages: work_package_id},
          {showWithEntitiesNormalized: ''}
        ];
      }
      this.requestUObject({
        url: url
      }).then(() => {
      let work_package = JSON.parse(JSON.stringify(this.$store.state.Ultra[`${prefix}workpackages`][work_package_id]));
        [
          {prop: 'work', getter: 'TWork'},
          {prop: 'defect', getter: 'TDefect'},
          {prop: 'quality', getter: 'TQuality'},
          {prop: 'handover', getter: 'THandover'},
          {prop: 'design', getter: 'TLogistic'},
          {prop: 'cost', getter: 'TCost'},
          {prop: 'logistic', getter: 'TLogistic'},
          {prop: 'material', getter: 'TMaterial'},
          {prop: 'machine', getter: 'TMachine'},
          // `worksteps`,
          // `defectsteps`,
          // `qualitysteps`,
          // `handoversteps`,
          // `logisticsteps`,
          // `designsteps`,
          // `workpackageimages`,
        ].forEach(type => {
          if (add_steps) {
            work_package[`w${type.prop}steps`] = work_package[`${prefix}${type.prop}steps`].map(id => this.getUObject({type: `${prefix}${type.prop}steps`, id: id}));
          } else {
            work_package[`w${type.prop}steps`] = [];
          }
            delete work_package[`${prefix}${type.prop}steps`];
        });
        work_package.wworkpackageimages = this.getUObjects({type: `${prefix}workpackageimages`, ids: work_package[`${prefix}workpackageimages`]});
        delete work_package[`${prefix}workpackageimages`];

          // delete work_package.created;
          // delete work_package.id;
          // delete work_package.owner;
          // delete work_package.updated;
          work_package.hashtags = [];
          let calls = [];
          work_package.wworkpackageimages.forEach(image => {
            calls.push(
              new Promise((resolve, reject) => {
              let xhr = new XMLHttpRequest();
              xhr.open("GET", image.image);
              xhr.responseType = "blob";
              xhr.onload = function()
              {
                 if (xhr.readyState === 4) {
                     if (xhr.status === 200) {
                         resolve(xhr.response);
                     }
                     else {
                         console.error(xhr.statusText);
                         reject(xhr.statusText);
                     }
                 } else {
                     reject(xhr.statusText);
                 }
                };
                xhr.setRequestHeader("mode", "no-cors");
                xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
                xhr.send();
              })
            );
          });
          Promise.all(calls)
          .then(resps => {
            for (let i = 0; i < resps.length; i++) {
              let file = new File([resps[i]], "image");
              work_package.wworkpackageimages[i].file = file;
              work_package.wworkpackageimages[i].local_url = URL.createObjectURL(file);
            }
            resolve_complete(work_package);
          });
        });
      });
    },
  }
};
